import { NgModule } from '@angular/core';
import { ShopboxCommonModule } from '@shared/common/common.module';
import { BreadCrumbNavComponent } from './components';



@NgModule({
    imports: [
        ShopboxCommonModule,
        BreadCrumbNavComponent
    ],
    exports: [
        BreadCrumbNavComponent
    ]
})
export class BreadCrumbsNavigationModule { }
